"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var ControlLabel_1 = __importDefault(require("../../Common/ControlLabel"));
var CheckboxIcon_1 = __importDefault(require("./CheckboxIcon"));
var styles_1 = require("./styles");
exports.Checkbox = react_2.forwardRef(function (_a, ref) {
    var _b = _a.checked, checked = _b === void 0 ? false : _b, _c = _a.indeterminate, indeterminate = _c === void 0 ? false : _c, label = _a.label, _d = _a.labelPosition, labelPosition = _d === void 0 ? 'after' : _d, onChange = _a.onChange, disabled = _a.disabled, error = _a.error, subLabel = _a.subLabel, _e = _a.type, type = _e === void 0 ? 'default' : _e;
    var theme = react_1.useTheme();
    indeterminate = type === 'circle' ? false : indeterminate;
    var styles = react_2.useMemo(function () { return styles_1.getCheckboxIconStyles(theme, type); }, [theme, type]);
    return (react_1.jsx(ControlLabel_1.default, { label: label, subLabel: subLabel, labelPosition: labelPosition, css: !disabled && styles.root },
        react_1.jsx("input", { css: styles_1.defaultInputStyle, type: "checkbox", checked: checked, disabled: disabled, onChange: function (e) { return onChange === null || onChange === void 0 ? void 0 : onChange(e.target.checked); }, ref: function (el) {
                el && (el.indeterminate = indeterminate);
                ref && (ref.current = el);
            } }),
        react_1.jsx(CheckboxIcon_1.default, { checked: checked, indeterminate: indeterminate, disabled: disabled, error: error, type: type })));
});
exports.default = Object.assign(exports.Checkbox, { Icon: CheckboxIcon_1.default });
